import React, { Component } from "react"

class General extends Component {
    render() {
        return (
            <div
                style={{
                    maxWidth: "640px",
                    margin: "20px auto",
                    color: "#fff",
                    fontSize: "24px",
                }}
            >
                General Page
            </div>
        )
    }
}

export default General



// WEBPACK FOOTER //
// ./src/pages/general/general.js